import React, { useCallback, useEffect, useState } from 'react';

const ImageLightbox = ({ images, index, onClose, onChange, renderCaption }) => {
  const [touchStart, setTouchStart] = useState(null);

  const total = images?.length || 0;
  const current = index != null && total > 0 ? images[index] : null;
  const canNav = total > 1;

  const go = useCallback((direction) => {
    if (!canNav) return;
    const nextIndex = (index + direction + total) % total;
    onChange(nextIndex);
  }, [canNav, index, onChange, total]);

  useEffect(() => {
    if (current == null) return undefined;

    const onKey = (event) => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'ArrowRight') go(-1);
      if (event.key === 'ArrowLeft') go(1);
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [current, go, onClose]);

  if (!current) return null;

  const src = current.file_url || current.image_url || current.src;
  const alt = current.title || current.name_ar || 'صورة';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
      onClick={onClose}
      onTouchStart={(e) => setTouchStart(e.changedTouches[0].clientX)}
      onTouchEnd={(e) => {
        if (touchStart == null) return;
        const delta = e.changedTouches[0].clientX - touchStart;
        if (Math.abs(delta) > 50) go(delta > 0 ? -1 : 1);
        setTouchStart(null);
      }}
    >
      <button
        type="button"
        className="absolute end-4 top-4 z-10 rounded-full bg-white/15 px-3 py-1 text-2xl text-white hover:bg-white/25"
        onClick={onClose}
        aria-label="إغلاق"
      >
        ×
      </button>

      {canNav && (
        <button
          type="button"
          className="absolute start-3 top-1/2 z-10 -translate-y-1/2 rounded-full bg-white/15 px-4 py-3 text-2xl text-white hover:bg-white/25 md:start-6"
          onClick={(e) => { e.stopPropagation(); go(-1); }}
          aria-label="الصورة السابقة"
        >
          ›
        </button>
      )}

      {canNav && (
        <button
          type="button"
          className="absolute end-3 top-1/2 z-10 -translate-y-1/2 rounded-full bg-white/15 px-4 py-3 text-2xl text-white hover:bg-white/25 md:end-6"
          onClick={(e) => { e.stopPropagation(); go(1); }}
          aria-label="الصورة التالية"
        >
          ‹
        </button>
      )}

      <div className="max-w-5xl text-center text-white" onClick={(e) => e.stopPropagation()}>
        <img src={src} alt={alt} className="mx-auto max-h-[80vh] max-w-full rounded-2xl object-contain" />
        <div className="mt-3 space-y-1">
          {canNav && <p className="text-sm text-white/70">{index + 1} / {total}</p>}
          {renderCaption ? renderCaption(current) : current.title && <p>{current.title}</p>}
        </div>
      </div>
    </div>
  );
};

export default ImageLightbox;
